<div class="p-8 flex flex-col max-w-[610px] relative">
  <fa-icon
    class="absolute top-4 right-4 text-base opacity-70 cursor-pointer"
    [icon]="'xmark'"
    (click)="onClose()"
  ></fa-icon>
  <div class="mb-3">
    <!-- cdkFocusInitial is a hack to avoid auto focusing on buttons
    couldn't find another way to do it -->
    <h1 class="text-2xl font-bold mb-3" cdkFocusInitial>
      {{ 'paid-publication-modal.title' | translate }}
    </h1>
    <p
      class="opacity-70 mb-3"
      [innerHTML]="'paid-publication-modal.message' | translate: { price: addOnPrice }"
    ></p>
    @if ((noIosPublishingData$ | async) === false) {
      <div class="flex flex-col gap-3">
        <rk-radio-button
          [label]="'paid-publication-modal.buy-android' | translate"
          [name]="'platform'"
          [value]="'android'"
          (selectionChange)="onSelectPlatform('android')"
        ></rk-radio-button>
        <rk-radio-button
          [label]="'paid-publication-modal.buy-ios' | translate"
          [name]="'platform'"
          [value]="'ios'"
          (selectionChange)="onSelectPlatform('ios')"
        ></rk-radio-button>
      </div>
    }
  </div>
  <div class="flex justify-end gap-2 md:gap-4">
    <rk-button
      [text]="'paid-publication-modal.cancel' | translate"
      [variant]="'secondary'"
      (buttonClick)="onClose()"
    ></rk-button>
    <rk-button
      [text]="'paid-publication-modal.buy' | translate"
      (buttonClick)="onBuyAddon(selectedPlatform)"
      [disabled]="selectedPlatform === null"
    ></rk-button>
  </div>
</div>
